export default {
  windowScrollTop () {
    return (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
  },
  preloadImages (imgSrcs) {
    return new Promise((resolve) => {
      let images = []
      let promises = []

      for (var i = 0; i < imgSrcs.length; i++) {
        promises[i] = new Promise(resolve => {
          images[i] = new Image()
          images[i].addEventListener('load', function handler () {
            this.removeEventListener('load', handler)
            resolve()
          })
          images[i].src = imgSrcs[i]
        })
      }

      Promise.all(promises).then(() => {
        resolve(images)
      })
    })
  },
  urlEncodeData (data) {
    var buffer = []
    for (let key in data) {
      if (!data.hasOwnProperty(key)) continue
      let encodedKey = encodeURIComponent(key)
      let encodedValue = encodeURIComponent(data[key])
      buffer.push(encodedKey + '=' + encodedValue)
    }
    buffer = buffer.join('&')
    return buffer
  },
  formatDate (date, shortForm) {
    let dateObj = new Date(date)

    if (!(dateObj instanceof Date && isFinite(dateObj))) return ''
    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    if (shortForm) {
      months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
    let dateStr = months[dateObj.getMonth()] + ' ' + dateObj.getDate() + ', ' + dateObj.getFullYear()
    return dateStr
  },
  objIsEmpty (obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object
  }
}



// WEBPACK FOOTER //
// ./src/services/services.js